import { SET_LOADING, SET_INTERCOM ,SET_CURRENT_MODULE} from "./constants";
export default {
	[SET_LOADING]: (state, payload) => (state.loading = payload),
	[SET_INTERCOM]: (state, payload) => (state.intercomRunning = payload),
	[SET_CURRENT_MODULE]: (state, payload) => (state.currentModule = payload)
	
};
